import '@/style/index.scss'
import { VueQueryPlugin } from '@tanstack/vue-query'
import 'virtual:uno.css'
import { createSSRApp } from 'vue'

import App from './App.vue'
import { prototypeInterceptor, requestInterceptor, routeInterceptor } from './interceptors'
import { goBackPage,cellPhone,copyData,openLocation,requireImg} from './utils/common'
import store from './store'

export function createApp() {
  const app = createSSRApp(App)
  app.use(store)
  app.use(routeInterceptor)
  app.use(requestInterceptor)
  app.use(prototypeInterceptor)
  app.use(VueQueryPlugin)
  app.config.globalProperties.$goBackPage = goBackPage
  app.config.globalProperties.$cellPhone = cellPhone
  app.config.globalProperties.$copyData = copyData
  app.config.globalProperties.$openLocation = openLocation
  app.config.globalProperties.$requireImg = requireImg
  return {
    app,
  }
}
